package io.horion.cv.api.datasource.common

enum class Type {
    PERSONNEL, OTHERS
}